// Refer to `./page-designer-custom/cartridges/module_pagedesigner_custom/cartridge/client/default/js/components/carousel.js` for scripts.